import { useState, useEffect } from 'react';
import Lottie from 'react-lottie-player';
import useInterval from '@use-it/interval';
import LedSettingsRing from '../webapp/events/LedSettingsRing';

const STATIC_POSE_TIPS = [
  {
    id: 'blow_a_kiss',
    name: 'Blow a Kiss',
    url: 'https://pbsco-static.s3-us-west-2.amazonaws.com/poseTips/default/JSON/blow_a_kiss.json',
    thumbnail: 'https://pbsco-static.s3-us-west-2.amazonaws.com/poseTips/default/PNG/blow_a_kiss.png',
  },
  {
    id: 'flex',
    name: 'Flex',
    url: 'https://pbsco-static.s3-us-west-2.amazonaws.com/poseTips/default/JSON/flex.json',
    thumbnail: 'https://pbsco-static.s3-us-west-2.amazonaws.com/poseTips/default/PNG/flex.png',
  },
  {
    id: 'tongue_out',
    name: 'Tongue Out',
    url: 'https://pbsco-static.s3-us-west-2.amazonaws.com/poseTips/default/JSON/tongue_out.json',
    thumbnail: 'https://pbsco-static.s3-us-west-2.amazonaws.com/poseTips/default/PNG/tongue_out.png',
  },
];

const BoothDemo = ({ boothType, ledRing, ledColor, startScreenUrl, poseTips = false }) => {
  const [replacedUrl, setReplacedUrl] = useState(null);
  const [currentPoseTip, setCurrentPoseTip] = useState(null);
  const [poseTipData, setPoseTipData] = useState([]);

  useEffect(() => {
    Promise.all(STATIC_POSE_TIPS.map((tip) => fetch(tip.url)))
      .then((responses) => Promise.all(responses.map((res) => res.json())))
      .then((urls) => {
        setPoseTipData(urls);
        setCurrentPoseTip(0);
      });
  }, []);

  useEffect(() => {
    if (startScreenUrl && /\/asset-library\/tap-to-start\//.test(startScreenUrl)) {
      let newUrl = startScreenUrl.replace('/asset-library/', '/asset-thumbnails/');
      newUrl = newUrl.replace('.mp4', '.m4v');
      setReplacedUrl(newUrl);
    }
  }, [startScreenUrl]);

  useInterval(
    () => {
      setCurrentPoseTip(currentPoseTip >= STATIC_POSE_TIPS.length - 1 ? 0 : currentPoseTip + 1);
    },
    currentPoseTip !== null ? 5000 : null
  );

  const renderUrl = replacedUrl || startScreenUrl;
  let boothScreen = null;
  if (poseTips && currentPoseTip !== null) {
    boothScreen = (
      <div className="booth-img__screen booth-img__screen--pose-tip">
        <Lottie
          key={STATIC_POSE_TIPS[currentPoseTip].id}
          animationData={poseTipData[currentPoseTip]}
          play
          style={{ width: 200, height: 200 }}
        />
      </div>
    );
  } else if (renderUrl) {
    if (['mp4', 'm4v'].includes(renderUrl.split('.').pop())) {
      boothScreen = <video className="booth-img__screen" src={renderUrl} autoPlay loop muted playsInline />;
    } else {
      boothScreen = <img alt="" className="booth-img__screen" src={renderUrl} />;
    }
  }
  return (
    <div className={['booth-img', 'booth-img--lg', boothType === 'guac' && 'booth-img--guac'].join(' ')}>
      {boothScreen}
      <img
        className="booth-img__booth"
        src={boothType === 'guac' ? '/static/booth/guac-led-background.png' : '/static/booth/salsa2.png'}
        alt=""
      />
      {ledRing ? (
        <img className="booth-img__ring" src={`/static/booth/led-patterns/${ledRing}.svg`} alt="" />
      ) : ledColor ? (
        <LedSettingsRing color={ledColor} />
      ) : null}
    </div>
  );
};

export default BoothDemo;
